//import React from "react"
import firebase from 'firebase';
import moment from 'moment';

export class CreateService {
  createOne = (resource, params) => {
    console.log('createOne', resource, params);
    if (!params.data.title) {
      throw new Error("Vous devez d'abord ajouter un titre");
    } else if (resource === 'missions') {
      const {
        pic_thumbnail: thumbnail,
        pic_cover: cover,
        title,
        subtitle,
        description,
        location,
        startDate,
        endDate,
        state
      } = params.data;

      const creationTime = Math.floor(new Date() / 1000);

      const saveMediaAndGetUrl = (media, type) => {
        if (media) {
          let { title: mediaName } = media;
          let mediaFile = media.rawFile;
          let mediaBlob = new Blob([mediaFile]);

          return firebase
            .storage()
            .ref(`missions/${creationTime}/${type}_pictures`)
            .child(mediaName)
            .put(mediaBlob)
            .then(() => {
              return firebase
                .storage()
                .ref(`missions/${creationTime}/${type}_pictures`)
                .child(mediaName)
                .getDownloadURL()
                .then(url => {
                  return { url, title: mediaName };
                });
            })
            .catch(error => {
              console.error(error);
              return '';
            });
        }
        return '';
      };

      const formatDate = date => {
        return moment(date).format('lll');
      };

      return Promise.all([
        saveMediaAndGetUrl(cover, 'cover'),
        saveMediaAndGetUrl(thumbnail, 'thumbnail')
      ]).then(([coverUrl, thumbnailUrl]) => {
        const pushableData = {
          creationTime: creationTime,
          title: title ? title : '',
          subtitle: subtitle ? subtitle : '',
          description: description ? description : '',
          pic_thumbnail: {
            src: thumbnailUrl ? thumbnailUrl.url : '',
            title: thumbnailUrl ? thumbnailUrl.title : ''
          },
          pic_cover: {
            src: coverUrl ? coverUrl.url : '',
            title: coverUrl ? coverUrl.title : ''
          },
          location: location ? location : '',
          startDate: startDate ? formatDate(startDate) : 'Jan 01, 2019 0:00 AM',
          endDate: endDate ? formatDate(endDate) : 'Dec 31, 2019 11:59 PM',
          state: state ? state : ''
        };
        return firebase
          .database()
          .ref(`${resource}`)
          .push(pushableData)
          .then(() => {
            console.log('Data created with success params.data', params.data);
            return { data: { id: creationTime, ...params.data } };
          });
      });
    } else {
      return firebase
        .database()
        .ref(`${resource}`)
        .push(params.data)
        .then(result => {
          return { data: params.data };
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/CreateService.js